/** The activity feed's alert: a short 880 Hz beep through WebAudio, silent where WebAudio is missing. */
let context: AudioContext | null = null;

export function playActivityBeep(): void {
  try {
    const Ctor = (globalThis as { AudioContext?: typeof AudioContext }).AudioContext;
    if (!Ctor) return;
    context ??= new Ctor();
    if (context.state === 'suspended') void context.resume().catch(() => undefined);
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.value = 880;
    gain.gain.value = 0.1;
    oscillator.connect(gain).connect(context.destination);
    const start = context.currentTime;
    oscillator.start(start);
    oscillator.stop(start + 0.12);
    oscillator.onended = () => {
      oscillator.disconnect();
      gain.disconnect();
    };
  } catch {
    // An alert sound is a nicety: a blocked or broken audio context must never break the feed.
  }
}
